module.exports = __webpack_public_path__ + "img/19_55.b10363dd.png";